import { render, staticRenderFns } from "./CartaoAprovadores.vue?vue&type=template&id=77bea8aa&scoped=true"
import script from "./CartaoAprovadores.vue?vue&type=script&setup=true&lang=js"
export * from "./CartaoAprovadores.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CartaoAprovadores.vue?vue&type=style&index=0&id=77bea8aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77bea8aa",
  null
  
)

export default component.exports